








import { Component, Prop, Vue } from 'vue-property-decorator'
import { Time } from '@/class/time'

@Component
export default class Timer extends Vue {
  @Prop() limitDate!: Date;
  time = new Time()
  countDownTime = 0;
  gap = 0;

  async created () {
    this.gap = await this.time.getGap()

    setInterval(() => {
      this.countDownTime = Math.floor((this.limitDate.getTime() - Date.now() - this.gap) / 1000)
      if (this.countDownTime < 0) {
        this.countDownTime = 0
      }
    }, 1000)

    this.$watch('countDownTime', (now, prev) => {
      if (now !== prev && now === 0) {
        this.$emit('timeover')
      }

      if (now === 20) {
        this.$emit('remind')
      }
    })
  }

  get isWarning () {
    return this.countDownTime > 0 && this.countDownTime <= 10
  }
}
